<div class="container-fluid" *ngIf="_Service.formHideShow==0">
    <div id="form-wrap">
        <h2 class="heading_all">SERVER PROVIDER MASTER</h2>
        <br>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>
            <div class="col-md-4 ">
                <table>
                    <thead>
                        <tr>
                            <td>
                                <button type="button" class="btn-sm btn-info" (click)="addNew()"><i class="fas fa-plus"
                                        aria-hidden="true"></i></button>
                            </td>
                            <td style="width:60%;"><input type="text" class="form-control-search" name="search"
                                    [(ngModel)]="term"></td>
                            <td><button class="btn-info"><i class="fas fa-search" aria-hidden="true"></i></button></td>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th>#</th>
                    <th class="hidden-xs" style="width:205px;">
                        <div class="AtjIsPoint" (click)="sort('Code')">
                            <span *ngIf="!_Service.isFiltering">Code</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_Service.orderByColName!='Code' "></i>
                                <div *ngIf="_Service.orderByColName=='Code'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_Service.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_Service.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_Service.isFiltering">
                            <input type="text" #txtCodeFilter="ngModel" [(ngModel)]="_Service.CodeFilter"
                                placeholder="Code">
                        </div>
                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('Name')">
                            <span *ngIf="!_Service.isFiltering">Name</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_Service.orderByColName!='Name' "></i>
                                <div *ngIf="_Service.orderByColName=='Name'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_Service.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_Service.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_Service.isFiltering">
                            <input type="text" #txtNameFilter="ngModel"
                                [(ngModel)]="_Service.NameFilter" placeholder="Name">
                        </div>
                    </th>
                    <th style="width: 135px;"><em></em> Settings
                        <a class="AtjIsPoint AtjfloatRight" (click)="toggleFilter()">
                            <i *ngIf="!_Service.isFiltering" class="fas fa-filter"></i>
                            <i *ngIf="_Service.isFiltering" class="fas fa-times"></i>
                        </a>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let obj of _Service.allServerProvider | orderBy : 'Name' | gridOperations  :_Service.pageIndex: 
                        {Code:_Service.CodeFilter,Name:_Service.NameFilter}:
                        {Column:_Service.orderByColName,Dir:_Service.orderByDir} ; let i = index"
                    class="ng-scope">
                    <td>{{i+1+((NoOfItems*_Service.pageIndex)-NoOfItems)}}</td>
                    <td style="width:205px;">{{obj.Code}}</td>
                    <td>{{obj.Name}}</td>
                    <td style="width: 135px;">
                        <button type="button" class="btn-success" (click)="onEdit(obj);">
                            <i class="fas fa-pen-square" aria-hidden="true"></i></button>
                        <button type="button" class="btn-danger" (click)="onDelete(obj.ID)"><i
                                class="fas fa-trash" aria-hidden="true"></i></button>
                    </td>
                </tr><!-- end ngRepeat: item in items -->
                <tr>
                    <td colspan="4"
                        *ngIf="(_Service.allServerProvider?.length<=0 )  || _CommonService.filterdItemCount<1">
                        No Records To Display.</td>
                </tr>
            </tbody>
            <tfoot>
                <td colspan="4" *ngIf="_CommonService.totalPageCount>1">
                    <app-grid-pagination (pageIndexValue)="_Service.pageIndex=$event">
                    </app-grid-pagination>
                </td>
            </tfoot>
        </table>
        <!-- <pagination-controls (pageChange)="p = $event"></pagination-controls> -->
        <div class="margintop"></div>
        <!-- </div>
    </div> -->
    </div>
</div>
<app-delete-confirm *ngIf="deletePopUp" [title]="'SERVER PROVIDER MASTER'" (ConfirmEvent)="dialogResult($event)"></app-delete-confirm>